// extracted by mini-css-extract-plugin
export default {"loadingSection":"LoadingSection_loadingSection__CfD+j","AnimateBG":"LoadingSection_AnimateBG__PbmXU"};